<template>
    <tr v-if="!showTransferForm && patient">
        <td>
            <FormatName :first-name="patient.patientName.firstName" :last-name="patient.patientName.lastName" />
            <br />
            <EmptyTextHandler :text="patient.isPatient ? 'Patient' : 'Referral'" />
            <br />
            <EmptyTextHandler :text="patient.patientMRN" />
            <br />
            <i class="me-2 fas fa-mobile-alt" />
            <a :href="`tel:${patient.primaryPhoneNumber}`">{{ formatPhone(patient.primaryPhoneNumber) }}</a>
        </td>
        <td v-if="patient.primaryAddress">
            {{ patient.primaryAddress.addressLine1 }}<br />
            {{ patient.primaryAddress.city }},
            {{ patient.primaryAddress.state }}
            {{ patient.primaryAddress.zipCode }}
        </td>
        <td v-else>
            <small><i class="text-default">Not Available</i></small>
        </td>
        <td>
            <EmptyTextHandler :text="patient.dateOfBirth ? formatDateFromDate(patient.dateOfBirth) : null" /><br />
            <EmptyTextHandler :text="patient.gender" />
        </td>
        <td>
            <EmptyTextHandler :text="patient.status" />
        </td>
        <td>
            <EmptyTextHandler :text="patient.startOfCare ? formatDateFromDate(patient.startOfCare) : null" /><br />
            <EmptyTextHandler :text="patient.dischargeDate ? formatDateFromDate(patient.dischargeDate) : null" />
        </td>
        <td>
            {{ ApplicationNamesEnum.getDescriptionUsingValue(patient.application) }}
        </td>
        <td>
            <EmptyTextHandler :text="patient.branchName" />
        </td>
        <td class="text-end">
            <div v-if="referableAgencyServices.length > 0">
                <button
                    v-if="patient.status == null || listOfStatuses.includes(patient.status)"
                    type="button"
                    :class="`btn table-btn btn-outline-info mr-${showEllipsis ? '2' : '4'}`"
                    v-tooltip="{ title: 'Refer Patient to another Provider', placement: 'bottom' }"
                >
                    <i class="fas fa-exchange-alt" @click="toggleShowTransferForm()" />
                </button>
                <button
                    type="button"
                    class="btn px-1 py-0 ms-1 btn-outline-primary icon-size"
                    data-bs-toggle="dropdown"
                    id="ReferralRow__Actions${id}"
                    v-if="showEllipsis"
                >
                    <i class="fas fa-ellipsis-h icon-size"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="ReferralRow__Actions${id}">
                    <a
                        class="dropdown-item"
                        href="javascript:void(0);"
                        v-if="
                            (patient.status === 'Non-Admitted' ||
                                patient.status === 'Discharged' ||
                                patient.status === 'Discharge' ||
                                patient.status === 'NonAdmit') &&
                            (patient.application === ApplicationEnum.AxxessHospiceFE ||
                                patient.application === ApplicationEnum.AxxessPalliative)
                        "
                        @click="handleConvertToPending(patient)"
                    >
                        Add Referral
                    </a>
                    <a
                        class="dropdown-item"
                        href="javascript:void(0);"
                        v-if="
                            patient.application === ApplicationEnum.HomeCare ||
                            patient.application === ApplicationEnum.AgencyCore
                        "
                        @click="handleReadmitPatient()"
                    >
                        Readmit
                    </a>
                </div>
            </div>
            <div v-else>
                <small><i class="text-default">No Actions Available</i></small>
            </div>
        </td>
    </tr>
    <template v-else>
        <tr class="transfer-form-row-one" v-if="patient">
            <td>
                <FormatName :first-name="patient.patientName.firstName" :last-name="patient.patientName.lastName" />
                <br />
            </td>
            <td v-if="patient.primaryAddress">
                {{ patient.primaryAddress.addressLine1 }}<br />
                {{ patient.primaryAddress.city }},
                {{ patient.primaryAddress.state }}
                {{ patient.primaryAddress.zipCode }}
            </td>
            <td v-else>
                <span class="align-middle">-</span>
            </td>
            <td>
                <div v-if="patient.dateOfBirth || patient.gender">
                    <EmptyTextHandler :text="patient.dateOfBirth ? formatDateFromDate(patient.dateOfBirth) : null" />
                    <br />
                    <EmptyTextHandler :text="patient.gender" />
                </div>
                <span class="align-middle" v-else>-</span>
            </td>
            <td>
                <div v-if="patient.status">
                    <EmptyTextHandler :text="patient.status" />
                </div>
                <span class="align-middle" v-else>-</span>
            </td>
            <td>
                <div v-if="patient.startOfCare || patient.dischargeDate">
                    <EmptyTextHandler :text="patient.startOfCare ? formatDateFromDate(patient.startOfCare) : null" />
                    <br />
                    <EmptyTextHandler
                        :text="patient.dischargeDate ? formatDateFromDate(patient.dischargeDate) : null"
                    />
                </div>
                <span class="align-middle" v-else>-</span>
            </td>
            <td>
                {{ ApplicationNamesEnum.getDescriptionUsingValue(patient.application) }}
            </td>
            <td>
                <EmptyTextHandler :text="patient.branchName" />
            </td>
            <td class="text-end">
                <div class="big-text">
                    <i>Refer In Progress</i>
                </div>
            </td>
        </tr>
        <tr class="transfer-form-row-two edit-row">
            <td colspan="8" class="p-3 edit au-target">
                <FormSection>
                    <template #content>
                        <div class="row mx-2 px-3 pt-3">
                            <div class="form-group d-flex flex-column ps-lg-4 col-md-3">
                                <label for="form-check-label pb-1"
                                    >Classify Patient as Non-Admit <span class="text-danger">*</span></label
                                >
                                <div class="d-flex flex-row">
                                    <div class="form-check custom-radio">
                                        <input
                                            type="radio"
                                            id="non-admit-no"
                                            name="non-admit"
                                            class="form-check-input"
                                            v-model="isNonAdmit"
                                            :value="false"
                                            :disabled="isNonAdmitDisabled()"
                                        />
                                        <label class="form-check-label" for="non-admit-no">
                                            <span class="me-1">No</span>
                                        </label>
                                    </div>
                                    <div class="form-check custom-radio ps-4 ms-4">
                                        <input
                                            type="radio"
                                            id="non-admit-yes"
                                            name="non-admit"
                                            class="form-check-input"
                                            :value="true"
                                            v-model="isNonAdmit"
                                            :disabled="isNonAdmitDisabled()"
                                        />
                                        <label class="form-check-label" for="non-admit-yes">
                                            <span class="me-1">Yes</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-lg-2 ps-lg-0 me-lg-3 col-md-3">
                                <label for="task-name"> Refer To: </label>
                                <span class="text-danger">*</span>
                                <select
                                    id="task-name"
                                    class="form-select"
                                    v-model="referTo"
                                    @change="updateBranches(referTo.id)"
                                    @blur="v$.referTo.$touch"
                                >
                                    <option :value="null">Select Solution</option>
                                    <option
                                        v-for="(agency, index) of referableAgencyServices"
                                        :key="index"
                                        :value="agency"
                                    >
                                        <div v-show="agency.show">
                                            {{ agency.name }}
                                        </div>
                                    </option>
                                </select>
                                <span v-if="v$.referTo.$error" class="field-invalid">Field is required.</span>
                            </div>
                            <div class="form-group col-lg-2 col-md-3">
                                <label for="task-name">Branch: </label>
                                <span class="text-danger">*</span>

                                <select
                                    id="task-name"
                                    class="form-select"
                                    v-model="selectedBranch"
                                    :disabled="!referTo"
                                    @blur="v$.selectedBranch.$touch"
                                >
                                    <option value="null">Select Branch</option>

                                    <optgroup
                                        v-for="provider of providerList"
                                        :label="provider.name"
                                        :value="provider"
                                        :key="provider.name"
                                    >
                                        <option v-for="branch of provider.branches" :key="branch.name" :value="branch">
                                            {{ branch.name }}
                                        </option>
                                    </optgroup>
                                </select>
                                <span v-if="v$.selectedBranch.$error" class="field-invalid">Field is required.</span>
                            </div>
                            <div v-if="patient.isPatient" class="form-group col-lg-3 col-md-3">
                                <span :class="`form-group form-check mb-0 mt-4 ${canViewDoc ? '' : 'text-muted'}`">
                                    <input
                                        v-model="includePatientCharts"
                                        type="checkbox"
                                        class="form-check-input"
                                        id="includeCopyOfPatientChart"
                                        :disabled="!canViewDoc"
                                    />
                                    <label for="includeCopyOfPatientChart">Include Copy Of Patient Chart</label>
                                </span>
                                <!-- replace above code with the commented code once permission issue is resolved -->
                                <!-- <span :class="`form-group form-check mb-0 mt-4 ${canViewDoc ? '' : 'text-muted'}`">
                                    <input
                                        v-model="includePatientCharts"
                                        type="checkbox"
                                        class="form-check-input"
                                        id="includeCopyOfPatientChart"
                                        :disabled="!canViewDoc"
                                    />
                                    <label for="includeCopyOfPatientChart">Include Copy Of Patient Chart</label>
                                </span> -->
                            </div>
                        </div>
                        <div class="row mx-2 px-3 pb-2">
                            <div
                                :class="`form-group ps-lg-4 pe-lg-5 col-md-3 ${
                                    !isNonAdmit == true ? 'd-none' : 'd-block'
                                }`"
                            >
                                <label for="non-admit-date"> Non-Admit Date: </label>
                                <span class="text-danger">*</span>
                                <DatePicker :getDate="updateNonAdmitDate">
                                    <div class="input-group date datepickerInput">
                                        <input
                                            name="nonAdmitDate"
                                            type="text"
                                            class="form-control"
                                            placeholder="MM/DD/YYYY"
                                            v-model="nonAdmitDate"
                                            autocomplete="off"
                                            :disabled="!isNonAdmit"
                                            @blur="v$.nonAdmitDate.$touch"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                    </div>
                                </DatePicker>
                                <span v-if="v$.nonAdmitDate.$error" class="field-invalid">Field is required.</span>
                            </div>
                            <div
                                :class="`form-group col-lg-2 ps-lg-0 col-md-3 ${
                                    !isNonAdmit == true ? 'd-none' : 'd-block'
                                }`"
                            >
                                <label for="non-admit-reason"> Non-Admit Reason: </label>
                                <span class="text-danger">*</span>
                                <!-- <NewTypeahead
                                    :disabled="!isNonAdmit"
                                    :data="nonAdmitReasons"
                                    v-model:selectedOption="selectedNonAdmitReason"
                                    :clearOnBlur="true"
                                    placeholder="Enter Non-Admit Reason"
                                /> -->
                                <select
                                    id="non-admit-reason"
                                    class="form-select"
                                    v-model="selectedNonAdmitReason"
                                    :disabled="!isNonAdmit"
                                    @blur="v$.nonAdmitDate.$touch"
                                >
                                    <option value="">Select Non-Admit Reason</option>
                                    <option
                                        v-for="nonAdmitReason of nonAdmitReasons"
                                        :key="nonAdmitReason.name"
                                        :value="nonAdmitReason"
                                    >
                                        {{ nonAdmitReason.name }}
                                    </option>
                                </select>
                                <span v-if="v$.selectedNonAdmitReason.$error" class="field-invalid"
                                    >Field is required.</span
                                >
                            </div>
                        </div>
                    </template>
                </FormSection>
                <div class="text-center pt-3">
                    <button
                        type="button"
                        class="btn btn-primary btn-md au-target"
                        @click="convertToRefer()"
                        au-target-id="2039"
                    >
                        Refer
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-secondary btn-md ms-2 au-target"
                        @click="closeNonAdmitForm()"
                        au-target-id="2040"
                    >
                        Cancel
                    </button>
                </div>
            </td>
        </tr>
    </template>
</template>

<script lang="ts" src="./CreateInterimReferralRow.ts"></script>
